import type { QueryClickActionsMode } from "../../types";

export const ArchivedMode: QueryClickActionsMode = {
  name: "archived",
  hasDrills: false,
  clickActions: [],
};
